// Generated from the RSDKv3 decompilation's ScrVariable / ScrFunction enums (Script.cpp, with RETRO_USE_HAPTICS).

export const enum VAR {
  TEMPVALUE0 = 0,
  TEMPVALUE1 = 1,
  TEMPVALUE2 = 2,
  TEMPVALUE3 = 3,
  TEMPVALUE4 = 4,
  TEMPVALUE5 = 5,
  TEMPVALUE6 = 6,
  TEMPVALUE7 = 7,
  CHECKRESULT = 8,
  ARRAYPOS0 = 9,
  ARRAYPOS1 = 10,
  GLOBAL = 11,
  OBJECTENTITYNO = 12,
  OBJECTTYPE = 13,
  OBJECTPROPERTYVALUE = 14,
  OBJECTXPOS = 15,
  OBJECTYPOS = 16,
  OBJECTIXPOS = 17,
  OBJECTIYPOS = 18,
  OBJECTSTATE = 19,
  OBJECTROTATION = 20,
  OBJECTSCALE = 21,
  OBJECTPRIORITY = 22,
  OBJECTDRAWORDER = 23,
  OBJECTDIRECTION = 24,
  OBJECTINKEFFECT = 25,
  OBJECTALPHA = 26,
  OBJECTFRAME = 27,
  OBJECTANIMATION = 28,
  OBJECTPREVANIMATION = 29,
  OBJECTANIMATIONSPEED = 30,
  OBJECTANIMATIONTIMER = 31,
  OBJECTVALUE0 = 32,
  OBJECTVALUE1 = 33,
  OBJECTVALUE2 = 34,
  OBJECTVALUE3 = 35,
  OBJECTVALUE4 = 36,
  OBJECTVALUE5 = 37,
  OBJECTVALUE6 = 38,
  OBJECTVALUE7 = 39,
  OBJECTOUTOFBOUNDS = 40,
  PLAYERSTATE = 41,
  PLAYERCONTROLMODE = 42,
  PLAYERCONTROLLOCK = 43,
  PLAYERCOLLISIONMODE = 44,
  PLAYERCOLLISIONPLANE = 45,
  PLAYERXPOS = 46,
  PLAYERYPOS = 47,
  PLAYERIXPOS = 48,
  PLAYERIYPOS = 49,
  PLAYERSCREENXPOS = 50,
  PLAYERSCREENYPOS = 51,
  PLAYERSPEED = 52,
  PLAYERXVELOCITY = 53,
  PLAYERYVELOCITY = 54,
  PLAYERGRAVITY = 55,
  PLAYERANGLE = 56,
  PLAYERSKIDDING = 57,
  PLAYERPUSHING = 58,
  PLAYERTRACKSCROLL = 59,
  PLAYERUP = 60,
  PLAYERDOWN = 61,
  PLAYERLEFT = 62,
  PLAYERRIGHT = 63,
  PLAYERJUMPPRESS = 64,
  PLAYERJUMPHOLD = 65,
  PLAYERFOLLOWPLAYER1 = 66,
  PLAYERLOOKPOS = 67,
  PLAYERWATER = 68,
  PLAYERTOPSPEED = 69,
  PLAYERACCELERATION = 70,
  PLAYERDECELERATION = 71,
  PLAYERAIRACCELERATION = 72,
  PLAYERAIRDECELERATION = 73,
  PLAYERGRAVITYSTRENGTH = 74,
  PLAYERJUMPSTRENGTH = 75,
  PLAYERJUMPCAP = 76,
  PLAYERROLLINGACCELERATION = 77,
  PLAYERROLLINGDECELERATION = 78,
  PLAYERENTITYNO = 79,
  PLAYERCOLLISIONLEFT = 80,
  PLAYERCOLLISIONTOP = 81,
  PLAYERCOLLISIONRIGHT = 82,
  PLAYERCOLLISIONBOTTOM = 83,
  PLAYERFLAILING = 84,
  PLAYERTIMER = 85,
  PLAYERTILECOLLISIONS = 86,
  PLAYEROBJECTINTERACTION = 87,
  PLAYERVISIBLE = 88,
  PLAYERROTATION = 89,
  PLAYERSCALE = 90,
  PLAYERPRIORITY = 91,
  PLAYERDRAWORDER = 92,
  PLAYERDIRECTION = 93,
  PLAYERINKEFFECT = 94,
  PLAYERALPHA = 95,
  PLAYERFRAME = 96,
  PLAYERANIMATION = 97,
  PLAYERPREVANIMATION = 98,
  PLAYERANIMATIONSPEED = 99,
  PLAYERANIMATIONTIMER = 100,
  PLAYERVALUE0 = 101,
  PLAYERVALUE1 = 102,
  PLAYERVALUE2 = 103,
  PLAYERVALUE3 = 104,
  PLAYERVALUE4 = 105,
  PLAYERVALUE5 = 106,
  PLAYERVALUE6 = 107,
  PLAYERVALUE7 = 108,
  PLAYERVALUE8 = 109,
  PLAYERVALUE9 = 110,
  PLAYERVALUE10 = 111,
  PLAYERVALUE11 = 112,
  PLAYERVALUE12 = 113,
  PLAYERVALUE13 = 114,
  PLAYERVALUE14 = 115,
  PLAYERVALUE15 = 116,
  PLAYEROUTOFBOUNDS = 117,
  STAGESTATE = 118,
  STAGEACTIVELIST = 119,
  STAGELISTPOS = 120,
  STAGETIMEENABLED = 121,
  STAGEMILLISECONDS = 122,
  STAGESECONDS = 123,
  STAGEMINUTES = 124,
  STAGEACTNO = 125,
  STAGEPAUSEENABLED = 126,
  STAGELISTSIZE = 127,
  STAGENEWXBOUNDARY1 = 128,
  STAGENEWXBOUNDARY2 = 129,
  STAGENEWYBOUNDARY1 = 130,
  STAGENEWYBOUNDARY2 = 131,
  STAGEXBOUNDARY1 = 132,
  STAGEXBOUNDARY2 = 133,
  STAGEYBOUNDARY1 = 134,
  STAGEYBOUNDARY2 = 135,
  STAGEDEFORMATIONDATA0 = 136,
  STAGEDEFORMATIONDATA1 = 137,
  STAGEDEFORMATIONDATA2 = 138,
  STAGEDEFORMATIONDATA3 = 139,
  STAGEWATERLEVEL = 140,
  STAGEACTIVELAYER = 141,
  STAGEMIDPOINT = 142,
  STAGEPLAYERLISTPOS = 143,
  STAGEACTIVEPLAYER = 144,
  SCREENCAMERAENABLED = 145,
  SCREENCAMERATARGET = 146,
  SCREENCAMERASTYLE = 147,
  SCREENDRAWLISTSIZE = 148,
  SCREENCENTERX = 149,
  SCREENCENTERY = 150,
  SCREENXSIZE = 151,
  SCREENYSIZE = 152,
  SCREENXOFFSET = 153,
  SCREENYOFFSET = 154,
  SCREENSHAKEX = 155,
  SCREENSHAKEY = 156,
  SCREENADJUSTCAMERAY = 157,
  TOUCHSCREENDOWN = 158,
  TOUCHSCREENXPOS = 159,
  TOUCHSCREENYPOS = 160,
  MUSICVOLUME = 161,
  MUSICCURRENTTRACK = 162,
  KEYDOWNUP = 163,
  KEYDOWNDOWN = 164,
  KEYDOWNLEFT = 165,
  KEYDOWNRIGHT = 166,
  KEYDOWNBUTTONA = 167,
  KEYDOWNBUTTONB = 168,
  KEYDOWNBUTTONC = 169,
  KEYDOWNSTART = 170,
  KEYPRESSUP = 171,
  KEYPRESSDOWN = 172,
  KEYPRESSLEFT = 173,
  KEYPRESSRIGHT = 174,
  KEYPRESSBUTTONA = 175,
  KEYPRESSBUTTONB = 176,
  KEYPRESSBUTTONC = 177,
  KEYPRESSSTART = 178,
  MENU1SELECTION = 179,
  MENU2SELECTION = 180,
  TILELAYERXSIZE = 181,
  TILELAYERYSIZE = 182,
  TILELAYERTYPE = 183,
  TILELAYERANGLE = 184,
  TILELAYERXPOS = 185,
  TILELAYERYPOS = 186,
  TILELAYERZPOS = 187,
  TILELAYERPARALLAXFACTOR = 188,
  TILELAYERSCROLLSPEED = 189,
  TILELAYERSCROLLPOS = 190,
  TILELAYERDEFORMATIONOFFSET = 191,
  TILELAYERDEFORMATIONOFFSETW = 192,
  HPARALLAXPARALLAXFACTOR = 193,
  HPARALLAXSCROLLSPEED = 194,
  HPARALLAXSCROLLPOS = 195,
  VPARALLAXPARALLAXFACTOR = 196,
  VPARALLAXSCROLLSPEED = 197,
  VPARALLAXSCROLLPOS = 198,
  SCENE_3DSCENENOVERTICES = 199,
  SCENE_3DSCENENOFACES = 200,
  VERTEXBUFFERX = 201,
  VERTEXBUFFERY = 202,
  VERTEXBUFFERZ = 203,
  VERTEXBUFFERU = 204,
  VERTEXBUFFERV = 205,
  FACEBUFFERA = 206,
  FACEBUFFERB = 207,
  FACEBUFFERC = 208,
  FACEBUFFERD = 209,
  FACEBUFFERFLAG = 210,
  FACEBUFFERCOLOR = 211,
  SCENE_3DSCENEPROJECTIONX = 212,
  SCENE_3DSCENEPROJECTIONY = 213,
  ENGINESTATE = 214,
  STAGEDEBUGMODE = 215,
  ENGINEMESSAGE = 216,
  SAVERAM = 217,
  ENGINELANGUAGE = 218,
  OBJECTSPRITESHEET = 219,
  ENGINEONLINEACTIVE = 220,
  ENGINEFRAMESKIPTIMER = 221,
  ENGINEFRAMESKIPSETTING = 222,
  ENGINESFXVOLUME = 223,
  ENGINEBGMVOLUME = 224,
  ENGINEPLATFORMID = 225,
  ENGINETRIALMODE = 226,
  KEYPRESSANYSTART = 227,
  ENGINEHAPTICSENABLED = 228,
  STAGEPLAYERCOUNT = 229,
}

export const enum FUNC {
  END = 0,
  EQUAL = 1,
  ADD = 2,
  SUB = 3,
  INC = 4,
  DEC = 5,
  MUL = 6,
  DIV = 7,
  SHR = 8,
  SHL = 9,
  AND = 10,
  OR = 11,
  XOR = 12,
  MOD = 13,
  FLIPSIGN = 14,
  CHECKEQUAL = 15,
  CHECKGREATER = 16,
  CHECKLOWER = 17,
  CHECKNOTEQUAL = 18,
  IFEQUAL = 19,
  IFGREATER = 20,
  IFGREATEROREQUAL = 21,
  IFLOWER = 22,
  IFLOWEROREQUAL = 23,
  IFNOTEQUAL = 24,
  ELSE = 25,
  ENDIF = 26,
  WEQUAL = 27,
  WGREATER = 28,
  WGREATEROREQUAL = 29,
  WLOWER = 30,
  WLOWEROREQUAL = 31,
  WNOTEQUAL = 32,
  LOOP = 33,
  SWITCH = 34,
  BREAK = 35,
  ENDSWITCH = 36,
  RAND = 37,
  SIN = 38,
  COS = 39,
  SIN256 = 40,
  COS256 = 41,
  SINCHANGE = 42,
  COSCHANGE = 43,
  ATAN2 = 44,
  INTERPOLATE = 45,
  INTERPOLATEXY = 46,
  LOADSPRITESHEET = 47,
  REMOVESPRITESHEET = 48,
  DRAWSPRITE = 49,
  DRAWSPRITEXY = 50,
  DRAWSPRITESCREENXY = 51,
  DRAWTINTRECT = 52,
  DRAWNUMBERS = 53,
  DRAWACTNAME = 54,
  DRAWMENU = 55,
  SPRITEFRAME = 56,
  EDITFRAME = 57,
  LOADPALETTE = 58,
  ROTATEPALETTE = 59,
  SETSCREENFADE = 60,
  SETACTIVEPALETTE = 61,
  SETPALETTEFADE = 62,
  COPYPALETTE = 63,
  CLEARSCREEN = 64,
  DRAWSPRITEFX = 65,
  DRAWSPRITESCREENFX = 66,
  LOADANIMATION = 67,
  SETUPMENU = 68,
  ADDMENUENTRY = 69,
  EDITMENUENTRY = 70,
  LOADSTAGE = 71,
  DRAWRECT = 72,
  RESETOBJECTENTITY = 73,
  PLAYEROBJECTCOLLISION = 74,
  CREATETEMPOBJECT = 75,
  BINDPLAYERTOOBJECT = 76,
  PLAYERTILECOLLISION = 77,
  PROCESSPLAYERCONTROL = 78,
  PROCESSANIMATION = 79,
  DRAWOBJECTANIMATION = 80,
  DRAWPLAYERANIMATION = 81,
  SETMUSICTRACK = 82,
  PLAYMUSIC = 83,
  STOPMUSIC = 84,
  PLAYSFX = 85,
  STOPSFX = 86,
  SETSFXATTRIBUTES = 87,
  OBJECTTILECOLLISION = 88,
  OBJECTTILEGRIP = 89,
  LOADVIDEO = 90,
  NEXTVIDEOFRAME = 91,
  PLAYSTAGESFX = 92,
  STOPSTAGESFX = 93,
  NOT = 94,
  DRAW3DSCENE = 95,
  SETIDENTITYMATRIX = 96,
  MATRIXMULTIPLY = 97,
  MATRIXTRANSLATEXYZ = 98,
  MATRIXSCALEXYZ = 99,
  MATRIXROTATEX = 100,
  MATRIXROTATEY = 101,
  MATRIXROTATEZ = 102,
  MATRIXROTATEXYZ = 103,
  TRANSFORMVERTICES = 104,
  CALLFUNCTION = 105,
  ENDFUNCTION = 106,
  SETLAYERDEFORMATION = 107,
  CHECKTOUCHRECT = 108,
  GETTILELAYERENTRY = 109,
  SETTILELAYERENTRY = 110,
  GETBIT = 111,
  SETBIT = 112,
  PAUSEMUSIC = 113,
  RESUMEMUSIC = 114,
  CLEARDRAWLIST = 115,
  ADDDRAWLISTENTITYREF = 116,
  GETDRAWLISTENTITYREF = 117,
  SETDRAWLISTENTITYREF = 118,
  GET16X16TILEINFO = 119,
  COPY16X16TILE = 120,
  SET16X16TILEINFO = 121,
  GETANIMATIONBYNAME = 122,
  READSAVERAM = 123,
  WRITESAVERAM = 124,
  LOADTEXTFONT = 125,
  LOADTEXTFILE = 126,
  DRAWTEXT = 127,
  GETTEXTINFO = 128,
  GETVERSIONNUMBER = 129,
  SETACHIEVEMENT = 130,
  SETLEADERBOARD = 131,
  LOADONLINEMENU = 132,
  ENGINECALLBACK = 133,
  HAPTICEFFECT = 134,
}
